export const getInterruptionNotificationTitle = (count: number) => {
  const unit = count === 1 ? 'interruption' : 'interruptions';
  return `You have ${count} active ${unit}`;
};

export const getInterruptionToastMessage = (count: number): string => {
  return `You have ${count} new interruption${count !== 1 ? 's' : ''}.`;
};
